export default __webpack_public_path__ + "static/media/border.0d18ee14.png";